<template>
  <q-breadcrumbs color="primary" active-color="primary">
    <q-icon name="keyboard_arrow_right" slot="separator" slot-scope="props" size="16px" color="info" />
    <q-breadcrumbs-el label="" icon="home" :to="homeUrl" class="uppercase q-caption"></q-breadcrumbs-el>
    <q-breadcrumbs-el
      v-for="(crumb, index) in $breadcrumbs"
      v-if="crumb.meta && crumb.meta.title"
      :key="index"
      class="uppercase q-caption"
      :label="crumb.meta.title"
      :to="crumb.path"
    />
  </q-breadcrumbs>
</template>
<script>
export default {
  props: {
    homeUrl: {
      type: String,
      default: () => '/'
    }
  },
  name: 'BreadCrumbs'
}
</script>
